import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

const BRON_INFO: Record<string, { label: string; url?: string; description: string }> = {
  rdw: {
    label: 'RDW Open Data',
    url: 'https://opendata.rdw.nl',
    description: 'Voertuigregistraties uit RDW Socrata datasets (m9d7-ebf2, 8ys7-d773).',
  },
  ocm: {
    label: 'OpenChargeMap',
    url: 'https://openchargemap.org',
    description: 'Open database van laadinfrastructuur wereldwijd.',
  },
  ndw: {
    label: 'NDW',
    description: 'Nationale Databank Wegverkeersgegevens. Verkeersintensiteiten per meetpunt.',
  },
  handmatig: {
    label: 'Handmatig',
    description: 'Handmatig ingevoerde data door gebruiker.',
  },
  schatting: {
    label: 'Schatting',
    description: 'Geschatte waarde op basis van vergelijkbare locaties of aannames.',
  },
  gemeente: {
    label: 'Gemeente',
    description: 'Data aangeleverd door of verkregen via gemeente.',
  },
  cbs: {
    label: 'CBS Statline',
    url: 'https://opendata.cbs.nl',
    description: 'Centraal Bureau voor de Statistiek. Demografische en economische data.',
  },
  rai: {
    label: 'RAI Vereniging',
    url: 'https://www.raivereniging.nl',
    description: 'Branchevereniging voor de mobiliteitsindustrie. Kwartaalcijfers voertuigverkoop.',
  },
  demo: {
    label: 'Demo-data',
    description: 'Voorbeelddata voor demonstratie. Niet gebaseerd op live bronnen.',
  },
};

interface DataSourceBadgeProps {
  bron: string;
  lastSync?: string | null;
  isLive?: boolean;
  className?: string;
}

export function DataSourceBadge({ bron, lastSync, isLive, className = '' }: DataSourceBadgeProps) {
  const info = BRON_INFO[bron] ?? { label: bron, description: '' };
  const liveDot = isLive === true ? 'bg-emerald-500' : isLive === false ? 'bg-amber-400' : 'bg-gray-400';

  const lastSyncLabel = lastSync
    ? new Date(lastSync).toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    : null;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={`inline-flex items-center gap-1 text-xs text-gray-500 ${className}`}>
            <span className={`w-1.5 h-1.5 rounded-full ${liveDot}`} />
            {info.label}
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">
          <div className="space-y-1 text-xs">
            <div className="font-medium">{info.label}</div>
            {info.description && <div className="text-muted-foreground">{info.description}</div>}
            {info.url && <div className="text-blue-500">{info.url}</div>}
            {lastSyncLabel && <div className="text-muted-foreground">Laatste sync: {lastSyncLabel}</div>}
            {isLive === false && <div className="text-amber-600">Geen live verbinding — demo-data wordt getoond</div>}
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
